import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { SSH_ImageViewer } from "../../../../components/molecules/ImageViewer/ImageViewer.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { useDropdownImageSize } from "../../../../hooks/useDropdownImageSize/useDropdownImageSize.hook";
import { V1Props } from "./ImageV1.interface";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./ImageV1.module.scss";

const V1 = (props: V1Props) => {
    const { backgroundColorClass, hasBackgroundColor } = useBackgroundColor(props.backgroundColor);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { imageDropdownSizeClass } = useDropdownImageSize(props.dropdownImageSize, S);

    return (
        <div className={cn(S.wrapper, paddingClass, backgroundColorClass, imageDropdownSizeClass)}>
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Image */}
                    {props.image ? (
                        <div className={S.imageWrapper}>
                            <SSH_ImageViewer
                                src={props.image.url}
                                aspectRatioX={props.image.width}
                                aspectRatioY={props.image.height}
                                alternative={props.image.alternative}
                            />

                            {/** Caption */}
                            {props.image.caption ? (
                                <div className={S.caption}>{props.image.caption}</div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
